// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {SizeTokenValue} from 'common';

import type {HTMLAttributes, ReactNode} from 'react';
import type {CSSObject} from '@emotion/react';

import type {QA, PropsWithChildren} from 'common';

export enum BannerVariant {
  DefaultBlue = 'defaultBlue',
  DefaultGrey = 'defaultGrey',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export type BannerStyles = {
  /** Вариант */
  variant: BannerVariant;
  /** Размер */
  size: SizeTokenValue;
  /** Цвет текста */
  color?: string;
} & Pick<CSSObject, 'backgroundColor' | 'borderColor' | 'width' | 'maxWidth'>;

export type BannerProps = {
  /**
   * boolean - Показывать иконку по "варианту"
   *
   * ReactNode - Кастомная иконка
   * */
  icon?: boolean | ReactNode;

  /** Заголовок */
  title?: ReactNode;

  /** Контрол справа */
  actionsTop?: ReactNode;

  /** Контрол снизу */
  actionsBottom?: ReactNode;

  /** Обработчик закрытия */
  onClose?: () => void;
} & Partial<BannerStyles> &
  QA &
  PropsWithChildren &
  Pick<HTMLAttributes<HTMLDivElement>, 'className'>;
